export default {
  ebookPage: {
    all: { ID: 787, CN: "全部", TR: "전부" },
    driveType: { ID: 2366, CN: "驱动类型", TR: "드라이브 유형" },
    motor: { ID: 846, CN: "电机", TR: "모터" },
    diesel: { ID: 1085, CN: "柴油机", TR: "디젤 엔진" },
    noProfile: { ID: 2469, CN: "暂无简介", TR: "프로필 없음" },
    serieslist: { ID: 1, CN: "电子样本", TR: "전자 견본" },
    motorFrequency: { ID: 72, CN: "电机频率", TR: "모터 빈도" },
    motorStandard: { ID: "", CN: "单位频率", TR: "모터 주파수" },

    displayMode: { ID: 670, CN: "显示方式", TR: "디스플레이 방식" },
    list: { ID: 672, CN: "列表", TR: "목록" },
    grid: { ID: 673, CN: "网格", TR: "격자" },
    keyWord: { ID: 668, CN: "关键词", TR: "키워드" },
    keyWordRule: { ID: 1010, CN: "请输入关键字", TR: "키워드를 입력해주세요" },
    view: { ID: 251, CN: "查询", TR: "조회" },
    queryResults: { ID: 2477, CN: "查询结果", TR: "결과검색" },
    operation: { ID: 1019, CN: "操作", TR: "작동" },
    download: { ID: 449, CN: "下载", TR: "다운로드" },
    type: { ID: 246, CN: "类型", TR: "유형" },
    name: { ID: 447, CN: "名称", TR: "명칭" },
    updateTime: { ID: 765, CN: "更新时间", TR: "업데이트 시간" },
    version: { ID: 766, CN: "文件版本", TR: "파일 버전" },
    lang: { ID: 450, CN: "语言", TR: "언어" },
    size: { ID: 1527, CN: "文件尺寸", TR: "파일 사이즈" },
    desc: { ID: 448, CN: "文件描述", TR: "설명" },
    emptyFlowAndHead: {
      ID: 2535,
      CN: "流量和扬程不能为空",
      TR: "유량 및 양정은 비워 둘 수 없습니다",
    },
    details: { ID: 999, CN: "详情", TR: "상세정보" },
    noData: { ID: "", CN: "暂无数据", TR: "데이터 없음" },

    pumpList: { ID: 123, CN: "水泵列表", TR: "물펌프 목록" },
    spectrumList: { ID: 6, CN: "系列型谱", TR: "시리즈 스펙트럼" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "실물도" },
    seriesDescription: { ID: 144, CN: "系列说明", TR: "시리즈 설명" },
    seriesDocuments: { ID: 694, CN: "系列文档", TR: "시리즈" },
    video: { ID: 695, CN: "详情视频", TR: "동영상" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D 모형" },
    export: { ID: 277, CN: "导出", TR: "보내기" },
    no: { ID: 696, CN: "序号", TR: "순번" },
    flow: { ID: 47, CN: "流量", TR: "유량" },
    head: { ID: 48, CN: "扬程", TR: "양정" },
    catalog: { ID: 2446, CN: "按类型", TR: "유형에 따라" },

    selectIndustry: { ID: "", CN: "选择行业", TR: "업종 선택" }, //yy加一个选择泵业
    choosePump: { ID: 2369, TR: "选择泵业", TR: "펌프업 선택" },
    allSeries: { ID: 2018, CN: "所有系列", TR: "모든 시리즈" },
    productStructure: { ID: "", CN: "产品结构", TR: "제품 구조" },

    screen: { ID: "", CN: "筛选", TR: "필터링" },
    search: { ID: 177, CN: "搜索", TR: "검색" },
    deviceList: { ID: "", CN: "设备列表", TR: "장치 목록" },
  },
  selectPage: {
    basicParameters: { ID: 1846, CN: "基本参数", TR: "기본 매개변수" },
    drive: { ID: "", CN: "驱动", TR: "구동" },
    acceptanceTolerance: {
      ID: "",
      CN: "验收容差",
      TR: "수용 한도를 검사하다.",
    },
    toleranceStandard: { ID: "", CN: "容差标准", TR: "허용 한도 기준" },
    toleranceLevel: { ID: "", CN: "容差等级", TR: "허용 한도 등급" },
    flowRange: { ID: "", CN: "流量范围", TR: "트래픽 범위" },
    headRange: { ID: "", CN: "扬程范围", TR: "양정 범위" },
    otherSelectionCriteria: {
      ID: "",
      CN: "其他选型条件",
      TR: "기타 선택 조건",
    },
    applicationArea: { ID: 2339, CN: "应用领域", TR: "응용 분야" },
    municipalWaterManagement: { ID: "", CN: "市政", TR: "시정" },
    industrialAndMining: { ID: "", CN: "工矿", TR: "공광" },
    constructionApplications: { ID: "", CN: "建筑", TR: "건축" },
    filterCriteria: { ID: "", CN: "筛选结果", TR: "필터 결과" },

    selparas: { ID: 5, CN: "参数选型", TR: "파라미터 모델 선정" },
    selResult: { ID: 2425, CN: "选型结果", TR: "모델 선정 리포트" },
    index: { ID: 1489, CN: "首页", TR: "첫 페이지" },
    selRow: { ID: 731, CN: "列选择", TR: "열선택" },
    export: { ID: 277, CN: "导出", TR: "보내기" },
    print: { ID: 193, CN: "打印", TR: "인쇄" },
    previous: { ID: 367, CN: "上一步", TR: "이전" },
    physical: { ID: 183, CN: "实物图", TR: "실물도" },
    series: { ID: 254, CN: "系列", TR: "시리즈" },
    model: { ID: 100, CN: "型号", TR: "모델" },
    diagram: { ID: 773, CN: "曲线图", TR: "곡선도" },
    flow: { ID: 47, CN: "流量", TR: "유량" },
    head: { ID: 48, CN: "扬程", TR: "양정" },
    shaftPower: { ID: 109, CN: "轴功率", TR: "축 출력" },
    efficiency: { ID: 108, CN: "效率", TR: "효율" },
    inputPower: { ID: "", CN: "输入功率",TR:"입력 전력" },
    unitEfficiency: { ID: "", CN: "机组效率",TR:"승무원 효율"},
    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 110, CN: "转速", TR: "캐비테이션" },
    impellerDiameter: { ID: 223, CN: "叶轮直径", TR: "임펠러 직경" },
    details: { ID: 990, CN: "详情", TR: "상세정보" },

    certifiedTraffic: { ID: "", CN: "认证流量", TR: "인증 트래픽" },
    certifiedHead: { ID: "", CN: "认证扬程", TR: "인증 스피드" },
    certifiedSpeed: { ID: "", CN: "认证转速", TR: "인증 회전 속도" },
    pointFlow_150: { ID: "", CN: "150%点流量", TR: "150% 포인트 트래픽" },
    pointLift_150: { ID: "", CN: "150%点扬程", TR: "150% 양정" },
    pointPower_150: { ID: "", CN: "150%点功率", TR: "150% 포인트 출력" },
    maxShaftPower: { ID: "", CN: "最大轴功率", TR: "최대 축 전력" },
    deadCenterLift: { ID: "", CN: "关死点扬程", TR: "관사점 양정" },
    pumpStages: { ID: "", CN: "泵级数", TR: "펌프 레벨" },
    note: { ID: "", CN: "备注", TR: "비고" },

    gotoIndexPage: { ID: 2479, CN: "返回首页", TR: "첫 페이지로 되돌리기" },
    quickSelection: { ID: 2426, CN: "快速选型", TR: "스피드 모델 선정" },
    advancedSelection: { ID: 2427, CN: "高级选型", TR: "고급 모델 선정" },
    workingConditions: { ID: 2428, CN: "工况条件", TR: "근로 조건" },
    productSeries: { ID: 2429, CN: "产品系列", TR: "제품 시리즈" },
    driveType: { ID: 2430, CN: "驱动类型", TR: "드라이브 유형" },
    setFrequency: { ID: 2431, CN: "设置频率", TR: "빈도 설정" },
    moreDesignPoints: { ID: 1481, CN: "更多设计点", TR: "설계점 더보기" },
    hide: { ID: 2432, CN: "隐藏", TR: "숨기기" },
    secondDpFlow: { ID: 2433, CN: "第二设计点流量", TR: "제2 설계점 유량" },
    secondDpHead: { ID: 2434, CN: "第二设计点扬程", TR: "제2 설계점 양정" },
    thirdDpFlow: { ID: 2435, CN: "第三设计点流量", TR: "제3 설계점 유량" },
    thirdDpHead: { ID: 2436, CN: "第三设计点扬程", TR: "제3 설계점 양정" },
    firePump: { ID: 2396, CN: "消防泵", TR: "소방펌프" },
    motorPoleNum: { ID: 2437, CN: "电机级数", TR: "모터급수" },
    moreSet: { ID: 2438, CN: "更多设置", TR: "설정 더보기" },
    put: { ID: 2439, CN: "收起", TR: "접기" },
    expand: { ID: "",CN:"展开", TR: "확장" },
    motorPowerStd: { ID: 2440, CN: "电气标准", TR: "모터 출력 표준" },
    mediaName: { ID: 2441, CN: "介质名称", TR: "매개 명칭" },
    mediumTemperature:{ID:"",CN:"介质温度",TR:"매체 온도"},
    cleanWater: { ID: 465, CN: "清水", TR: "클린 워터" },
    maxTemperature: { ID: 2442, CN: "最高温度", TR: "최고온도" },
    customMediaProp: {
      ID: 2443,
      CN: "自定义介质属性",
      TR: "자체 정의 매개 속성",
    },
    maxDensity: { ID: 2444, CN: "最大密度", TR: "최대밀도" },
    mediumViscosity: { ID: 2445, CN: "介质粘度", TR: "매개 점도" },
    nextStep: { ID: 368, CN: "下一步", TR: "다음" },
    selectAll: { ID: 97, CN: "全选", TR: "모두 선택" },
    reselect: { ID: 366, CN: "重选", TR: "다시 선택" },
    invert: { ID: "", CN: "反选", TR: "역선" },
    modelList: { ID: 443, CN: "型号列表", TR: "모델목록" },
    byType: { ID: 2446, CN: "按类型", TR: "유형에 따라" },
    byIndustry: { ID: 2447, CN: "按行业", TR: "업종에 따라" },
    byMedia: { ID: 2480, CN: "按介质", TR: "매개에 따라" },
    type: { ID: 246, CN: "类型", TR: "유형" },
    applicationArea: { ID: 2448, CN: "应用领域", TR: "응용 분야" },
    flowRule: { ID: 2665, CN: "请输入流量", TR: "유량을 입력하세요" },
    headRule: { ID: 1156, CN: "请输入扬程", TR: "양정을 입력하세요" },
    leastOneType: {
      ID: "",
      CN: "至少选择一种类型",
      TR: "최소 한 가지 유형 선택",
    },
    seriesRule: {
      ID: 2451,
      CN: "至少选择一个系列",
      TR: "하나 이상의 시리즈 선택",
    },
    hangyeRule: {
      ID: 2481,
      CN: "至少选择一个行业",
      TR: "1개 이상의 업종을 선택해주세요",
    },
    jiezhiRule: {
      ID: 2482,
      CN: "至少选择一种介质",
      TR: "1개 이상의 매개를 선택해주세요",
    },
    dieselEngineSpeedRule: {
      ID: 2450,
      CN: "请输入柴油机转速",
      TR: "디젤엔진 회전속도를 입력화세요",
    },
    dieselEngineSpeed: { ID: 2449, CN: "柴油机转速", TR: "디젤엔진 회전속도" },
    pleaseSelect: { ID: 2077, CN: "请选择", TR: "선택해주세요" },

    custom: { ID: 2236, CN: "自定义", TR: "자체 정의" },
    unlimited: { ID: "", CN: "不限", TR: "무제한" },

    toleranceStand: { ID: "", CN: "验收容差标准", TR: "검수 용차 기준" },
    toleranceGrade: { ID: "", CN: "验收容差等级", TR: "검수 용차 등급" },
    MinFlowPercentage: {
      ID: "",
      CN: "最小流量百分比",
      TR: "최소 트래픽 백분율",
    },
    MaxFlowPercentage: { ID: "", CN: "最大流量百分比", TR: "최대 트래픽 비율" },
    MinHeadPercentage: {
      ID: "",
      CN: "最小扬程百分比",
      TR: "최소 스피드 백분율",
    },
    MaxHeadPercentage: {
      ID: "",
      CN: "最大扬程百分比",
      TR: "최대 스피드 백분율",
    },

    findErr1: {
      ID: "",
      CN: "未查找到相关型号,请修改相关选型参数",
      TR: "관련 모델을 찾을 수 없습니다. 관련 선택 매개 변수를 수정하십시오.",
    },
    findErr2: {
      ID: "",
      CN: "未查找到相关型号,将在三秒后返回上一页",
      TR: "관련 모델을 찾을 수 없습니다. 3초 후에 이전 페이지로 돌아갑니다.",
    },
    QPerQBep: { ID: "", CN: "额定点", TR: "정격 점" },
    PerRated: { ID: "", CN: "铭牌参数综合偏差", TR: "명판 매개 변수 편차 값" },
    PerRatedQ: { ID: "", CN: "铭牌参数流量偏差",TR:"명판 매개 변수 유량 편차" },
    sortMethod: { ID: "", CN: "排序方式", TR: "정렬 방법" },
    efficiencySort: { ID: "", CN: "效率排序", TR: "효율성 정렬" },
    qPerQBepSort: { ID: "", CN: "综合排序", TR: "통합 정렬" },
    enum: { ID: 331, CN: "数量", TR: "수량" },
    modelSelection: { ID: 26, CN: "选型", TR: "모델 선택" },
    mediaLibrary: { ID: "", CN: "介质库", TR: "미디어 라이브러리" },
    volumeConcentration: { ID: "", CN: "体积浓度", TR: "체적농도" },
    mediaDescription: { ID: "", CN: "介质说明", TR: "미디어 설명" },
    isMediumParticles: {
      ID: "",
      CN: "含有介质颗粒",
      TR: "매체 입자가 있는지 여부",
    },

    vbr: { ID: "", CN: "变速率", TR: "VBR" },
    cuttingRate: { ID: "", CN: "切割率", TR: "절단률" },
    salesPrice: { ID: "", CN: "销售价", TR: "판매 가격" },
    originalImpellerDiameter: {
      ID: "",
      CN: "原始叶轮直径",
      TR: "원본 휠 지름",
    },
    ratedSpeed: { ID: "", CN: "额定转速", TR: "정격 회전 속도" },
    guidePrice: { ID: "", CN: "指导价", TR: "지도 가격" },
    secondDirectory: { ID: "", CN: "二级目录", TR: "레벨 2 디렉토리" },

    allowCutting: { ID: "",CN:"允许切割", TR: "가공 허용" },
    allowFrequencyConversion: { ID: "",CN:"允许变频", TR: "주파수 변환 허용"},
    efficiencyAndNPSH: { ID: "", CN: "效率和汽蚀", TR: "골라주세요" },
    minimumEfficiency: { ID: "", CN: "最低效率", TR: "최소 효율" },
    attributeFiltering: { ID: "", CN: "属性过滤", TR: "속성 필터링" },
    importedCaliber: { ID: "", CN: "进口口径", TR: "수입 구경" },
    exportCaliber: { ID: "", CN: "出口口径", TR: "출구경" },
    motorParameters: { ID: "", CN: "电机参数", TR: "모터 매개변수" },
    helpChoose: { ID: "", CN: "帮我选", TR: "골라주세요" },

    similarConversion:{ID:"",CN:"相似换算",TR:"유사 환산"},
    parameterDesign:{ID:"",CN:"参数设计",TR:"매개변수 설계"},
    selectionCondition:{ID:"",CN:"选型条件",TR:"선택 기준"},
    designRequirement:{ID:"",CN:"设计要求",TR:"설계 요구 사항"},
    calculationParameters:{ID:"",CN:"计算参数",TR:"매개변수 계산하기"},
    mediumDensity:{ID:"",CN:"介质密度",TR:"미디어 집적도"},
    selectionMethod:{ID:"",CN:"选型方法",TR:"모델 선택 방법"},
    pumpType:{ID:"",CN:"泵型",TR:"펌프형"},
    impellerType:{ID:"",CN:"叶轮类型",TR:"휠 유형"},
    modelLibrary:{ID:"",CN:"模型库",TR:"모델 라이브러리"},
    fixedSpeed:{ID:"",CN:"定转速",TR:"정전속"},
    specificSpeed:{ID:"",CN:"比转速",TR:"NS"},
    convertRangeBySpecificSpeed:{ID:"",CN:"比转速换算范围",TR:"회전 속도 대비 환산 범위"},
    efficiencyCorrection:{ID:"",CN:"效率修正",TR:"효율성 수정"},
    recommendModel:{ID:"",CN:"推荐模型",TR:"권장 모델"},
    DifferenceInSpecificSpeed:{ID:"",CN:"比转速差值",TR:"NS 차이"},
    originalModelInformation:{ID:"",CN:"原模型信息",TR:"원본 모델 정보"},
    afterConversion:{ID:"",CN:"换算后",TR:"환산 후"},
    scaleRatio:{ID:"",CN:"缩放系数",TR:"배율 계수"},
    yelunTips: { ID: "", CN: "请输入叶轮直径",TR:"휠 지름을 입력하십시오."},
    e_requirements:{ID:"",CN:"效率要求",TR:"효율성 요구 사항"},
    currentMotorPower:{ID:"",CN:"当前电机功率",TR:"현재 모터 전력"},
    requiredMotorPower:{ID:"",CN:"要求的电机功率",TR:'필요한 모터 전력'}, 
  },
  //详情页面
  detailPage: {
    userUnit: { ID: "", CN: "用户单位", TR: "사용자 단위" },
    standardUnit: { ID: "", CN: "标准单位", TR: "표준 단위" },

    report: { ID: 699, CN: "报告", TR: "리포트" },
    share: { ID: 700, CN: "分享", TR: "공유" },
    costAnalysis: { ID: 571, CN: "成本分析", TR: "원가분석" },
    medium: { ID: 1486, CN: "介质", TR: "매개" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D 모형" },
    scanQRShare: { ID: 2463, CN: "扫描二维码分享", TR: "QR코드 스캔 공유" },
    view: { ID: 251, CN: "查询", TR: "조회" },

    close: { ID: 460, CN: "关闭", TR: "닫기" },
    setUp: { ID: 470, CN: "设定", TR: "설정" },
    flowUnits: { ID: 2158, CN: "流量单位", TR: "유량단위" },
    headUnit: { ID: 2159, CN: "扬程单位", TR: "양정단위" },
    powerUnit: { ID: 2464, CN: "功率单位", TR: "출력단위" },
    npshUnit: { ID: "", CN: "汽蚀单位", TR: "NPSHr 유닛" },
    d2Unit: { ID: "", CN: "叶轮外径单位", TR: "D2 유닛" },
    followSystem: { ID: "", CN: "跟随系统", TR: "시스템 따라가기" },
    exitFull: { ID: 2465, CN: "退出全屏", TR: "전체 화면에서 나가기" },
    partNo: { ID: 159, CN: "产品编号", TR: "제품 일련번호" },
    materialGroup: { ID: 1753, CN: "材料组", TR: "재료그룹" },
    material: { ID: 1206, CN: "材料", TR: "재료" },

    selectionReport: { ID: 237, CN: "选型报告", TR: "모델 선정 리포트" },
    lang: { ID: 450, CN: "语言", TR: "언어" },
    fileFormat: { ID: 1585, CN: "文件格式", TR: "파일 형식" },
    buildFile: { ID: 2452, CN: "生成文件", TR: "파일 생성" },
    customerInfo: { ID: 787, CN: "客户信息", TR: "고객정보" },
    orderInformation: { ID: 873, CN: "订单信息", TR: "주문서 정보" },
    setReportContent: { ID: 878, CN: "设置报告内容", TR: "리포트 내용 설정" },
    reportInformation: { ID: "", CR: "报告信息",TR:"보고서 정보" },
    projectInformation: { ID: 89, CN: "项目信息", TR: "프로젝트 정보" },
    productName: { ID: 870, CN: "产品名称", TR: "제품 명칭" },
    projectCode: { ID: 1018, CN: "项目编号", TR: "항목번호" },
    projectName: { ID: 792, CN: "项目名称", TR: "항목이름" },
    itemNO: { ID: 793, CN: "工位编号", TR: "업무자리 번호" },
    customerName: { ID: 872, CN: "客户名称", TR: "고객 명칭" },
    customerAddress: { ID: 957, CN: "客户地址", TR: "고객 주소" },
    contactPerson: { ID: 760, CN: "联系人", TR: "연락 책임자" },
    contactInformation: { ID: 2753, CN: "联系方式", TR: "연락처" },
    email: { ID: 1842, CN: "邮箱", TR: "이메일" },
    website: { ID: 1843, CN: "网址", TR: "인터넷 주소" },
    country: { ID: 1844, CN: "国家", TR: "국가" },
    price: { ID: 875, CN: "产品单价", TR: "제품 단가" },
    productModel: { ID: "", CN: "订单中产品型号", TR: "주문 중인 모델" },
    pumpPeformance: { ID: 1837, CN: "订单号", TR: "주문 번호" },
    purchaseQuantity: { ID: 877, CN: "购买数量", TR: "구매 수량" },
    orderNote: { ID: 874, CN: "订单备注", TR: "주문서 비고" },
    pageReportSet: { ID: 2461, CN: "页面报告设置", TR: "페이지 설정" },
    isBWDispplay: {
      ID: 811,
      CN: "黑白显示曲线",
      TR: "흑백 디스플레이 여부",
    },
    dataAndCurve: {
      ID: 808,
      CN: "数据表和曲线",
      TR: "데이터 시트와 곡선(작은 그림)",
    },
    curveGraph: { ID: 1122, CN: "曲线图", TR: "곡선도 조회" },
    sizePicture: { ID: 701, CN: "尺寸图", TR: "치수도" },
    assemblyDrawing: { ID: 134, CN: "安装图", TR: "설치도" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "실물도" },
    explosionDiagram: { ID: "", CN: "爆炸图", TR: "폭발도" },
    modelDrawinUnit: { ID: 2462, CN: "实物图(机组)", TR: "실물도 (모터그룹)" },
    structureDrawing: { ID: 185, CN: "结构图", TR: "구성도" },
    outlineDrawing: { ID: "", CN: "安装尺寸图", TR: "설치 치수도" },
    pumpDimensions: { ID: "", CN: "泵头尺寸图", TR: "펌프 헤드 크기 그래프" },
    offerText: { ID: 805, CN: "报价文本", TR: "견적원본" },
    companyName: { ID: 1002, CN: "公司抬头", TR: "회사전칭" },
    companyWebsite: { ID: 1840, CN: "公司网址", TR: "회사 인터넷 주소" },
    performanceCurve: { ID: 218, CN: "性能曲线", TR: "성능곡선" },
    assemblyDrawingPart: {
      ID: 2453,
      CN: "安装图(单泵)",
      TR: "설치도(싱글펌프)",
    },
    assemblyDrawingSys: {
      ID: 2454,
      CN: "安装图(机组)",
      TR: "설치도(모터그룹)",
    },
    parameter: { ID: 111, CN: "参数", TR: "파라미터" },
    data: { ID: 2081, CN: "数据", TR: "데이터" },
    unit: { ID: 527, CN: "单位", TR: "단위" },
    operatingParameters: { ID: 2182, CN: "运行参数", TR: "운행 파라미터" },
    parameterQuery: { ID: 2455, CN: "参数查询", TR: "파라미터 조회" },
    installation: { ID: 2225, CN: "安装信息", TR: "설치 정보" },
    motor: { ID: 2226, CN: "电机信息", TR: "모터 정보" },
    documents: { ID: 694, CN: "系列文档", TR: "시리즈" },
    properties: { ID: 230, CN: "属性", TR: "속성" },
    flow: { ID: 47, CN: "流量", TR: "유량" },
    head: { ID: 48, CN: "扬程", TR: "양정" },
    frequency: { ID: "", CN: "频率", TR: "주파수" },

    seriesConnect: { ID: "", CN: "串联", TR: "직렬" },
    parallelConnect: { ID: "", CN: "并联", TR: "병렬 연결" },
    method: { ID: "", CN: "方式", TR: "방식" },
    update: { ID: "", CN: "更新", TR: "업데이트" },
    number: { ID: "", CN: "台数", TR: "대수" },
    queryParams: { ID: "", CN: "查询参数",TR:"질의 매개변수" },

    shaftPower: { ID: 109, CN: "轴功率", TR: "축 출력" },
    efficiency: { ID: 108, CN: "效率", TR: "효율" },
    inputPower: { ID: "", CN: "输入功率",TR:"입력 전력" },
    unitEfficiency: { ID: "", CN: "机组效率",TR:"승무원 효율"},
    press: { ID: "", CN: "压力", TR: "압력받다" },
    power: { ID: "", CN: "功率", TR: "파워" },
    impellerDia: { ID: "", CN: "叶轮外径", TR: "휠 외경" },
    motorPower: { ID: "", CN: "电机功率", TR: "모터 파워" },

    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 115, CN: "转速", TR: "회전 소도" },
    coefficient: { ID: 1143, CN: "系数", TR: "계수" },
    parameterSelection: { ID: 5, CN: "参数选型", TR: "파라미터 모델 선정" },
    allowableRegionMax: { ID: 2456, CN: "允许区域(大)", TR: "허용 영역 (대)" },
    allowableRegionMin: { ID: 2487, CN: "允许区域(小)", TR: "허용 영역 (소)" },
    optimalAreaMax: { ID: 2451, CN: "最优区域(大)", TR: "최적 영역 (대)" },
    optimalAreaMin: { ID: 2459, CN: "最优区域(小)", TR: "최적 영역 (소)" },
    closeDeadCenter: { ID: 2460, CN: "关死点", TR: "관사점" },
    bestAdvantage: { ID: 2466, CN: "最优点", TR: "최적점" },
    workingPoint: { ID: 203, CN: "工作点", TR: "작업 지점" },
    flowPoint150: { ID: 2467, CN: "流量150%点", TR: "유량150%점" },
    powerPointMax: { ID: 2468, CN: "最大功率点", TR: "최대출력점" },
    video: { ID: 695, CN: "系列视频", TR: "동영상" },
    picture: { ID: "",CN: "图片", TR: "그림" },

    variableSpeedCurve: { ID: 2483, CN: "变速曲线", TR: "변속곡선" },
    seriesParallelConnection:{ID: "", CN: "串并联曲线", TR: "병렬 연결"},
    displaySettings: { ID: 1663, CN: "显示设置", TR: "디스플레이 설정" },
    curveExport: { ID: 2404, CN: "曲线导出", TR: "곡선 보내기" },
    chartColor: { ID: 2485, CN: "图表颜色", TR: "그래프 색상" },
    monochrome: { ID: 139, CN: "单色", TR: "단색 디스플레이" },
    multicolour: { ID: 1930, CN: "彩色", TR: "채색" },
    spectrumDisplay: { ID: 2406, CN: "型谱显示", TR: "스펙트럼 디스플레이" },
    display: { ID: 217, CN: "显示", TR: "디스플레이" },
    noDisplay: { ID: 158, CN: "不显示", TR: "표시되지 않음" },
    onlyShowworkCurve: {
      ID: 2137,
      CN: "仅显示工作曲线",
      TR: "작업곡선만 디스플레이",
    },
    display_curve: {
      ID: "",
      CN: "显示在曲线末端",
      TR: "커브 끝에 표시",
    },
    displayPanel: {
      ID: "",
      CN: "显示在面板",
      TR: "패널에 표시",
    },
    speedList: { ID: 2487, CN: "速度列表", TR: "속도 목록" },
    addSpeed: { ID: 2488, CN: "添加速度", TR: "속도 추가" },
    addPinLv: { ID: 2379,CN:"添加频率", TR: "주파수 추가" },
    pleaseEnterSpeed: {
      ID: 1161,
      CN: "请输入转速",
      TR: "회전속도를 입력하세요",
    },
    pleaseEnterHz: { ID: "", CN: "请输入频率", TR: "주파수를 입력하십시오." },
    tip: { ID: 286, CN: "提示", TR: "알림" },
    define: { ID: 125, CN: "确定", TR: "확정" },
    cancel: { ID: 126, CN: "取消", TR: "취소" },
    download: { ID: 449, CN: "下载", TR: "다운로드" },
    downloadTips: {
      ID: 2489,
      CN: "请下载桌面程序,导出性能曲线",
      TR: "스크톱 프로그램을 다운로드하여 성능 곡선을 내보내십시오",
    },
    curve: { ID: 766, CN: "曲线图", TR: "그래프" },
    document: { ID: 984, CN: "文档", TR: "문서" },
    DocumentNone: { ID: "", CN: "文档(无)", TR: "문서 (없음)" },
    Model: { ID: "", CN: "模型", TR: "모델" },
    queryPoint: { ID: "", CN: "查询点", TR: "질의 점" },
    productNoSelect: { ID: "", CN: "产品编号选择", TR: "제품 번호 선택" },
    watermark: { ID: "", CN: "水印", TR: "워터마크가 있는지 여부" },
    IsPrintModel3d: { ID: "", CN: "产生三维页面", TR: "3D 페이지 생성 여부" },
    IsCreateMultiSpeedChart: { ID: "",CN:"产生变频曲线", TR: "인버터 커브 생성 여부" },
    queryCurve: { ID: "", CN: "查询曲线", TR: "커브 질의" }, //yy  add---
    parameterQuery: { ID: "", CN: "参数查询", TR: "매개변수 질의" },
    parameter_s: { ID: "", CN: "参数", TR: "매개변수" },
    parameterCancel: { ID: "", CN: "取消", TR: "취소" },
    parameterDetermine: { ID: "", CN: "确定", TR: "확인" },
    showDesignPoints: {
      ID: "",
      CN: "显示设计点",
      TR: "설계 점 표시",
    },
    designPointStyle: { ID: "", CN: "设计点样式", TR: "디자인 포인트 스타일" },
    crosshair: { ID: "", CN: "十字线", TR: "십자선" },
    invertedTriangle: {
      ID: "",
      CN: "倒三角",
      TR: "역삼각형",
    },
    roundDot: { ID: "", CN: "圆点", TR: "도트" },
    boldRightAngle: { ID: "", CN: "加粗直角", TR: "직각 굵게 만들기" },
    deviceCurve: { ID: "", CN: "装置曲线", TR: "기기 곡선" },
    displayIndex: { ID: "", CN: "显示", TR: "표시" },
    netHeadValue: { ID: "", CN: "净扬程值", TR: "순양정값" },
    displayCurve: { ID: "", CN: "显示曲线", TR: "커브 표시" },
    onlyDisplayCurve: {
      ID: "",
      CN: "仅显示工作曲线",
      TR: "작업 커브만 표시",
    },
    showAllCurves: { ID: "", CN: "显示所有曲线", TR: "모든 커브 표시" },
    outputChartToCAD: {
      ID: "",
      CN: "请下载客户端，客户端才能导出CAD格式文件",
      TR: "CAD 형식 파일을 내보내려면 클라이언트를 다운로드하십시오.",
    },
    inquiry: { ID: "", CN: "询价", TR: "가격 문의" },
    productInquiry: { ID: "", CN: "产品询价", TR: "제품 가격 조회" },
    address: { ID: "", CN: "地址", TR: "주소" },
    contactName: { ID: "", CN: "联系人名称", TR: "연락처 이름" },
    pumpModel: { ID: "", CN: "泵型号", TR: "펌프 모델" },
    pumpNumber: { ID: "", CN: "泵数量", TR: "펌프 수" },
    submit: { ID: "", CN: "提交", TR: "제출" },
    inquirtFormatte1: { ID: "", CN: "请输入联系方式", TR: "연락처 입력" },
    inquirtFormatte2: {
      ID: "",
      CN: "请输入联系人名称",
      TR: "연락처 이름을 입력하십시오.",
    },
    selectMedia: {
      ID: "",
      CN: "选择介质",
      TR: "미디어 선택",
    }, //yy add
    cleanWater: {
      ID: 459,
      CN: "清水",
      TR: "맑은 물",
    },
    viewDetail: {
      ID: 661,
      CN: "查看详情",
      TR: "자세히 보기",
    },
    sewage: {
      ID: 21,
      CN: "污水",
      TR: "오수",
    },
    viscousSlurry: {
      ID: "",
      CN: "污水、渣浆粘稠浆液",
      TR: "오수, 슬래그 펄프 점조 펄프",
    },
    chemicalLiquid: {
      ID: "",
      CN: "化学液体",
      TR: "화학 액체",
    },
    hydrocarbons: {
      ID: "",
      CN: "化学液体、烃类等",
      TR: "화학 액체, 탄화수소류 등",
    },
    Gas: {
      ID: "",
      CN: "气体",
      TR: "가스",
    },
    gasList: {
      ID: "",
      CN: "空气、油气、瓦斯",
      TR: "공기, 기름, 가스",
    },
    nameplateParameter: { ID: 2194, CN: "铭牌参数", TR: "표찰 파라미터" },
    angle: { ID: 1500, CN: "角度", TR: "각도" },
    printCompanyInfo: { ID: "", CN: "打印公司信息", TR: "회사 정보 인쇄" },
    auto: { ID: "", CN: "自动判断", TR: "자동" },
    original: { ID: "", CN: "原始方向", TR: "원시" },
    clockwise: { ID: "", CN: "顺时针方向", TR: "시계 바늘" },
    counterclockwise: { ID: "", CN: "逆时针方向", TR: "반시계 방향" },

    resize:{ID:"",TR:"크기 조정"},
    zoomIn:{ID:"",TR:"확대"},
    zoomOut:{ID:"",TR:"축소"},
    highlightModifyArea:{ID:"",TR:"수정 영역 강조 표시"},
    move:{ID:"",TR:"이동"},

    productConfig:{ID:"",CN:"产品配置",TR:"제품 구성"},
    exportSettings:{ID:"",CN:"导出设置",TR:"내보내기 설정"},
    path:{ ID: "", CN:"路径", TR:"경로" },
    monochromeDisplay:{ ID: "", CN:"单色显示", TR:"단색 디스플레이" },
    chartSettings:{ ID: "", CN:"图表设置", TR:"차트 설정" },
    selectionPoint:{ ID: "", CN:"选型点", TR:"선택 점" },
    nameplateParameterPoints:{ ID: "", CN:"铭牌参数点", TR:"명판 매개 변수점" },
    operatingArea:{ ID: "", CN:"运行区域", TR:"실행 영역" },
    optimalArea:{ ID: "", CN:"最优区域", TR:"최적 영역" },
    deviceArea:{ ID: "", CN:"装置区域", TR:"기기 영역" },
    flowHeadLine:{ ID: "", CN:"流量扬程线", TR:"유량 양정 선" },
    allHeadCurves:{ ID: "", CN:"所有扬程曲线", TR:"모든 양정 곡선" },
    flowEfficiencyLine:{ ID: "", CN:"流量效率线", TR:"트래픽 효율선" },
    onlyWorkingCurve:{ ID: "", CN:"仅工作曲线", TR:"작업 커브만" },
    flowPowerLine: { ID: "", CN:"流量功率线", TR:"유량 전력선" },
    AllPowerCurves:{ ID: "", CN:"所有功率曲线", TR:"모든 전력 커브" },
    textContent:{ ID: "", CN:"文本内容", TR:"텍스트 내용" },
    rotationAngle:{ ID: "", CN:"旋转角度", TR:"회전 각도" },
    fontSize:{ ID: "", CN:"文字大小", TR:"문자 크기" },
    alignmentMethod:{ ID: "", CN:"对齐方式", TR:"정렬" },
    fontColor:{ ID: "", CN:"文字颜色", TR:"텍스트 색상" },
    blod:{ ID: "", CN:"加粗", TR:"굵게" },
    italic:{ ID: "", CN:"倾斜", TR:"기울기" },
    leftRotation:{ ID: "", CN:"左旋转", TR:"좌회전" },
    rightRotation:{ ID: "", CN:"右旋转", TR:"오른쪽 회전" },
    equivalentLine:{ ID: "", CN:"等效线", TR:"등효선" },
    minFlowCurve: { ID: "", CN: "最小连续流量线",TR:"최소 유량 커브" },
    maximumEfficiencyPoint: { ID: "", CN: "高效点",TR:"최대 효율성" },
    allCurves:{ ID: "", CN:"所有曲线", TR:"모든 커브" },
    flowNPSHrCurve:{ ID: "", CN:"流量汽蚀线", TR:"트래픽 NPSHr 커브"},
    colorStyle:{ID: "", CN:"颜色样式", TR:"색상 스타일"},
    maxMinWorkingCurve: { ID: "", CN: "最大最小工作曲线",TR:"최대 최소 작업 커브" },
    errorTip: { ID: "", CN: "不能小于最小轴功率",TR:"최소 축 전력보다 작을 수 없음"},

    addCurve: { ID: "",CN:'添加曲线', TR: "커브 추가"},
    addFlowPoint: { ID: "", CN: "添加流量点", TR: "Д트래픽 추가"},
    byFrequency: { ID: "", CN: "按频率", TR: "주파수별"},
    bySpeed: { ID: "", CN: "按转速", TR: "회전 속도에 따라"},
    byOperatingPoint: { ID: "", CN: "按运行点", TR: "실행 지점별"},
    queryInfo: { ID: "", CN: "查询信息", TR: "질의 정보"},
    pointName: { ID: "", CN: "点名", TR: "출석체크"},

  },
  //报表分析
  LCC: {
    Analysis: { ID: 569, CN: "分析", TR: "분석" },
    accumulationCurve: { ID: 934, CN: "年度累计曲线", TR: "연도 누적곡선" },
    statisticalChart: { ID: 935, CN: "单年统计图", TR: "한 해 통계도" },
    workingPointFlow: { ID: 555, CN: "工作点流量", TR: "작업 지점 유량" },
    default: { ID: 928, CN: "默认", TR: "디폴트" },

    heating: { ID: 929, CN: "供暖", TR: "난방 공급" },
    pressurize: { ID: 930, CN: "增压", TR: "증압" },
    custom: { ID: 931, CN: "自定义", TR: "자체 정의" },
    status: { ID: 858, CN: "状态", TR: "상태" },
    flowRatio: { ID: 939, CN: "流量比例", TR: "유량 비례" },
    timeScale: { ID: 940, CN: "时间比例", TR: "시간 비례" },
    fullLoad: { ID: 941, CN: "全负荷", TR: "전부하" },
    partialLoad: { ID: 943, CN: "部分负荷", TR: "부분 부하" },
    nightCoolingOperation: {
      ID: 945,
      CN: "夜间降温运行",
      TR: "야간 온도 강하 운행",
    },
    lowLoad: { ID: 944, CN: "低负荷", TR: "저부하" },
    load: { ID: 2490, CN: "负荷", TR: "부하" },

    energyCosts: { ID: 561, CN: "能耗成本", TR: "에너지소모 원가" },
    workingDays: {
      ID: 556,
      CN: "每年大致工作天数",
      TR: "연도별 대체 근무 일수",
    },
    workingHours: { ID: 557, CN: "每天大致工作小时", TR: "매일 대략 근무시간" },
    powerFees: { ID: 567, CN: "电费", TR: "전기요금" },
    per: { ID: 565, CN: "每度", TR: "매도" },
    risiPowerPrice: { ID: 2491, CN: "电费上涨", TR: "전기요금 인상" },
    eachYear: { ID: 566, CN: "每年", TR: "매년" },
    CalcCycle: { ID: 558, CN: "计算周期", TR: "계산 주기" },
    year: { ID: 559, CN: "年", TR: "년" },
    interestRate: { ID: 560, CN: "利率", TR: "이율" },
    droop: { ID: 568, CN: "效率下降", TR: "시스템 효율 감소" },
    co2Ratio: { ID: 927, CN: "CO2系数", TR: "CO2 계수" },
    conversionFactor: { ID: 2536, CN: "煤炭折算系数", TR: "석탄 환산 계수" }, //!!!!!

    maintenanceCost: { ID: 536, CN: "维护维修成本", TR: "유지보수 원가" },
    thousand: { ID: 2492, CN: "千元", TR: "천원" },
    maintenance: { ID: 2493, CN: "维护和维修", TR: "유지보수" },
    runningCost: { ID: 542, CN: "运行费用", TR: "운행비용" },
    downtimeAndLoss: { ID: 540, CN: "生产停工和损耗", TR: "생산중단과 손실" },

    environmentalFee: { ID: 541, CN: "环境保护费", TR: "환경보호비용" },
    othersFee: { ID: 784, CN: "其他年费用", TR: "기타 연비용" },
    orderCost: { ID: 2494, CN: "设备采购费用", TR: "설비 구매비용" },
    installDebugCharge: { ID: 551, CN: "安装和调试", TR: "설치 및 디버깅" },
    tonAndkW: { ID: 2495, CN: "吨/万千瓦", TR: "톤/만kW" },

    mapOfCosts: { ID: 932, CN: "费用图", TR: "비용도" },
    costItem: { ID: 936, CN: "费用项", TR: "비용 사항" },
    cost: { ID: 937, CN: "费用", TR: "비용" },
    percentage: { ID: 938, CN: "百分比", TR: "백분율" },

    initialCost: { ID: 662, CN: "初期成本", TR: "초기 원가" },
    maintenanceAndRepair: { ID: 2493, CN: "维修和护理", TR: "유지보수" },
    co2: { ID: 2489, CN: "CO2", TR: "CO2" },
    coalConsumption: { ID: 2497, CN: "煤耗量", TR: "석탄 소모량" },

    totalAnnualCost: { ID: 949, CN: "年总费用", TR: "연도 총비용" },
    co2TotalEmissions: { ID: 2498, CN: "co2总排放量", TR: "co2 총 배출량" },
    tenThousand: { ID: 947, CN: "万", TR: "만" },
    tenThousandTon: { ID: 2499, CN: "万吨", TR: "만톤" },
    calculationPeriod: {
      ID: "",
      CN: "请输入计算周期",
      TR: "계산 주기를 입력하십시오!",
    }, //yy ---add
    scaleTime: {
      ID: "",
      CN: "请输入时间比例!",
      TR: "시간 비율을 입력하십시오!",
    },
    sumProportions: {
      ID: "",
      CN: "请输入时间比例之和为100%!",
      TR: "시간 비율의 합을 100% 로 입력하세요!",
    },
    electricCharge: {
      ID: "",
      CN: "请输入电费(每度)!",
      TR: "전기 요금 (도당) 을 입력하세요!",
    },
    coefficient_c: {
      ID: "",
      CN: "请输CO2系数!",
      TR: "CO2 계수 주세요!",
    },
    conversionCoefficient: {
      ID: "",
      CN: "请输入煤炭折算系数!",
      TR: "석탄 환산 계수를 입력하세요!",
    },
  },
  //首页
  indexPage: {
    corpIntroduction: { ID: 30, CN: "公司介绍", TR: "회사소개" },
    basicInformation: { ID: "", CN: "基础信息", TR: "기초 정보" },

    enterpriseHonors: { ID: 32, CN: "企业荣誉", TR: "기업 명예" },
    enterpriseStyle: { ID: 2393, CN: "企业风貌", TR: "기업풍모" },
    salesNetwork: { ID: 31, CN: "销售网络", TR: "영업 네트워크" },

    organizationStructure: { ID: "", CN: "组织结构", TR: "조직 구조" },
    corporateCulture: { ID: "", CN: "企业文化", TR: "기업 문화" },
    introductionToPumpAnimation: {
      ID: "",
      CN: "泵型动画介绍",
      TR: "펌프형 애니메이션 소개",
    },
    companyPortfolio: { ID: "", CN: "公式组合", TR: "공식 조합" },

    performanceSelection: {
      ID: 2394,
      CN: "水力性能选型",
      TR: "수력 성능 모델 선정",
    },
    productSearch: { ID: 778, CN: "产品搜索", TR: "제품검색" },
    contactinformation: { ID: 35, CN: "联系方式", TR: "연락처" },
    myProject: { ID: 1716, CN: "我的项目", TR: "내 프로젝트" },
    ebook: { ID: 2757, CN: "电子样本", TR: "전자 견본" },
    pdfFile: { ID: 1755, CN: "纸质样本", TR: "종이 견본" },
    application: { ID: 2500, CN: "行业应用", TR: "업종응용" },
    intelligentSelection: { ID: 2761, CN: "智能选型", TR: "스마트 모델 선정" },
    firePump: { ID: 2396, CN: "消防泵", TR: "소방펌프" },
    flow: { ID: 47, CN: "流量", TR: "유량" },
    head: { ID: 48, CN: "扬程", TR: "양정" },
    type: { ID: 246, CN: "类型", TR: "유형" },
    more: { ID: 741, CN: "更多", TR: "더보기" },
    nextStep: { ID: 368, CN: "下一步", TR: "다음" },
    zmSearch: { ID: 2501, CN: "按字母查找", TR: "자모로 검색" },
    alphaList: { ID: "", CN: "字母列表", TR: "알파벳 목록" },
    byType: { ID: 2446, CN: "按类型", TR: "유형에 따라" },
    byIndustry: { ID: 2447, CN: "按行业", TR: "업종에 따라" },
    product: { ID: "", CN: "产品", TR: "생산품" },
    material: { ID: "", CN: "资料", TR: "자료" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D 모형" },
    about_us: { ID: 2502, CN: "关于我们", TR: "우리에 대해" },
    product_catalog: { ID: 2503, CN: "产品目录", TR: "제품 목록" },
    product_selection: { ID: 2504, CN: "产品选型", TR: "제품 모델 선정" },
    letter_search: { ID: 2505, CN: "字母搜索", TR: "자모검색" },
    application_area: { ID: 2759, CN: "应用领域", TR: "응용분야" },
    application_HY: { ID: "", CN: "行业应用", TR: "응용 프로그램" },
    sample_Model: { ID: 2506, CN: "样本模型", TR: "견본모형" },
    corpInfo: { ID: 1802, CN: "公司信息", TR: "회사 정보" },
    searchByPumpImg: { ID: "", CN: "按产品图搜索", TR: "펌프 이미지로 검색" },
    pleaseSelect: { ID: 2077, CN: "请选择", TR: "선택해주세요" },
    viewNow: { ID: "", CN: "立即查看", TR: "지금 보기" },
    quick: { ID: "", CN: "快速", TR: "쾌속" },
    sampleBook: { ID: "", CN: "产品样本", TR: "제품 견본" },
    simpleAndDirect: { ID: "", CN: "清晰简捷", TR: "뚜렷하고 간편하다." },
    clearClassification: { ID: "", CN: "分类明确", TR: "분류가 명확하다" },
    quickProductSelection: { ID: "", CN: "产品快速选取", TR: "빠른 제품 선택" },
    productSamplePreview: {
      ID: "",
      CN: "产品样本预览",
      TR: "제품 샘플 미리 보기",
    },
    productNameAtoZ: { ID: "", CN: "产品名称A-Z", TR: "제품 이름 A-Z" },
    findApplications: {
      ID: "",
      CN: "发现适合您需求的应用",
      TR: "요구 사항에 적합한 어플리케이션 검색",
    },
    feedBack: { ID: "", CN: "问题反馈", TR: "질문 피드백" },
    feedbackContent: { ID: "", CN: "反馈内容", TR: "피드백 내용" },
    feedbackRule: {
      ID: "",
      CN: "联系人或联系方式不能为空",
      TR: "연락처 또는 연락처는 비워 둘 수 없습니다.!!",
    },
    problemType: { ID: "", CN: "问题类型", TR: "문제 유형" },
    rorExample: {
      ID: "",
      CN: "例如：软件问题、曲线错误",
      TR: "예: 소프트웨어 문제, 커브 오류",
    },

    add: { ID: 2752, CN: "公司地址", TR: "회사주소:" },
    companyAddress: {
      ID: "",
      CN: "浙江省湖州市德清县雷甸镇旭日路8号",
      TR: "절강성 호주 시 덕 청 구 뇌 상 진 욱 일 로 8 호",
    },
    tel: { ID: 2507, CN: "联系电话", TR: "연락처:" },
    email: { ID: 2508, CN: "企业邮箱", TR: "기업메일:" },
    hotline: { ID: 2509, CN: "全国同一服务热线", TR: "그물 모양:" },
    helpManual: { ID: "", CN: "帮助手册", TR: "도움말 안내서" },
    changePassword: { ID: "", CN: "修改密码", TR: "암호 수정" },
    queryCurve: { ID: "", CN: "查询曲线", TR: "커브 질의" }, //yy  add---
    parameterQuery: { ID: "", CN: "参数查询", TR: "매개변수 질의" },
    parameter_s: { ID: "", CN: "参数", TR: "매개변수" },
    parameterCancel: { ID: "", CN: "取消", TR: "취소" },
    parameterDetermine: { ID: "", CN: "确定", TR: "확인" },
    showDesignPoints: {
      ID: "",
      CN: "显示设计点",
      TR: "설계 점 표시",
    },
    designPointStyle: { ID: "", CN: "设计点样式", TR: "디자인 포인트 스타일" },
    crosshair: { ID: "", CN: "十字线", TR: "십자선" },
    invertedTriangle: {
      ID: "",
      CN: "倒三角",
      TR: "역삼각형",
    },
    roundDot: { ID: "", CN: "圆点", TR: "도트" },
    boldRightAngle: { ID: "", CN: "加粗直角", TR: "직각 굵게 만들기" },
    deviceCurve: { ID: "", CN: "装置曲线", TR: "기기 커브 표시" },
    displayIndex: { ID: "", CN: "显示", TR: "표시" },
    netHeadValue: { ID: "", CN: "净扬程值", TR: "순양정값" },
    displayCurve: { ID: "", CN: "显示曲线", TR: "커브 표시" },
    onlyDisplayCurve: {
      ID: "",
      CN: "仅显示工作曲线",
      TR: "작업 커브만 표시",
    },
    showAllCurves: { ID: "", CN: "显示所有曲线", TR: "모든 커브 표시" },
    outputChartToCAD: {
      ID: "",
      CN: "请下载客户端,客户端才能导出CAD格式文件",
      TR: "CAD 형식 파일을 내보내려면 클라이언트를 다운로드하십시오",
    },

    classAndSelection: { ID: "", CN: "分类选型", TR: "분류 선택" },
    industrySelection: { ID: "", CN: "行业选型", TR: "업종 선택" },
    projectList: { ID: "", CN: "项目列表", TR: "항목 목록" },
    customerList: { ID: "", CN: "客户列表", TR: "고객 목록" },

    marketSector: { ID: "", CN: "市场领域", TR: "시장 영역" },
    alphabeticSort: { ID: "", CN: "字母排序", TR: "문자 정렬" },
    companyWebsite: { ID: "", CN: "企业官网", TR: "기업 웹사이트" },
  },
  simpleLoginPage: {
    login: { ID: 2783, CN: "登录", TR: "로그인" },
    register: { ID: 2784, CN: "注册", TR: "회원가입" },
    enterVerificCode: {
      ID: 2510,
      CN: "请输入验证码",
      TR: "인증번호를 입력하세요",
    },
    verificCodeError: { ID: 2511, CN: "验证码错误", TR: "인증 번호 오류" },
    loginPrompt: { ID: 2512, CN: "登录提示", TR: "로그인 알림" },
    passwordError: { ID: 400, CN: "密码错误", TR: "비밀번호 오류" },
    loginSuccessful: {
      ID: 2513,
      CN: "登录成功,正在跳转~",
      TR: "로그인 성공, 건너뛰기 중~",
    },
    AccountLogin: { ID: 2514, CN: "账户登录", TR: "계정 로그인" },
    CodeScanningLogin: {
      ID: 2397,
      CN: "扫码登录",
      TR: "QR코드 스캔하여 로그인",
    },
    registerInfo: {
      ID: 2398,
      CN: "如果您还没有加入我们，可以点击下方的注册成为我们的一员",
      TR: "아직 가입하지 않으셨다면 아래 등록을 클릭하여 가입하실 수 있습니다",
    },
    registerInfoTitle: { ID: 2399, CN: "新用户", TR: "신규 사용자" },
    loginInfo: {
      ID: 2400,
      CN: "如果您已经是我们中的一员可以点击下方的登录，进入到我们的平台",
      TR: "이미 우리 멤버인 경우 아래 로그인을 클릭하여 우리 플랫폼에 접속할 수 있습니다",
    },
    loginInfoTitle: { ID: 2401, CN: "我们中的一员", TR: "우리중 1명" },
    userType: { ID: 2402, CN: "用户类型", TR: "사용자 유형" },
    loginName: { ID: 2403, CN: "账户名", TR: "계좌이름" },
    password: { ID: 378, CN: "密码", TR: "비밀번호" },
    userType0: { ID: 710, CN: "内部人员", TR: "내부인원" },
    userType1: { ID: 2404, CN: "外部人员", TR: "외부인원" },
    userType2: { ID: "",CN:"代理商", TR: "Agent" },
    phoneNumber: { ID: 379, CN: "手机号", TR: "핸드폰 번호" },
    email: { ID: 1842, CN: "邮箱", TR: "이메일" },

    forgetPassword: { ID: "", CN: "忘记密码", TR: "암호 잊음" },
    sendSuccess: { ID: "", CN: "发送成功", TR: "발송 성공" },
    verifyAccount: { ID: "", CN: "账号验证", TR: "계정 확인" },
    fillInInformation: { ID: "", CN: "填写信息", TR: "정보를 기입하다" },
    registerSuccess: { ID: "", CN: "注册成功", TR: "등록 성공" },
    registerTips: {
      ID: "",
      CN: "请填写您注册时的手机号",
      TR: "등록할 때의 핸드폰 번호를 기입해 주십시오",
    },
    forgetEmailTips: {
      ID: "",
      CN: "请填写您注册时的邮箱",
      TR: "등록할 때 이메일을 입력하십시오.",
    },
    verifyCode: { ID: "", CN: "验证码", TR: "인증 코드" },
    send: { ID: "", CN: "发送", TR: "보내다" },
    userAccount: { ID: "", CN: "用户账号", TR: "사용자 계정" },

    oldPassword: { ID: "", CN: "旧密码", TR: "이전 암호" },
    oldPsdTips: { ID: "", CN: "请输入旧密码", TR: "이전 암호를 입력하십시오." },
    newPassword: { ID: "", CN: "新密码", TR: "새 암호" },
    newPsdTips: { ID: "", CN: "请输入新密码", TR: "새 암호를 입력하십시오." },
    oldPwdRule: {
      ID: "",
      CN: "旧密码不能为空",
      TR: "이전 암호는 비워 둘 수 없습니다.",
    },
    newPwdRule: {
      ID: "",
      CN: "新密码不能为空",
      TR: "새 암호는 비워둘 수 없습니다",
    },
    oldAndNewPwdRule: {
      ID: "",
      CN: "新旧密码不能一致",
      TR: "신구 암호가 일치하지 않습니다.",
    },

    enterPwdAgain: {
      ID: "",
      CN: "请再次输入密码",
      TR: "암호를 다시 입력하십시오.",
    },
    enterTwoPwdDisaccord: {
      ID: "",
      CN: "两次输入密码不一致",
      TR: "두 번 입력한 암호가 일치하지 않습니다",
    },

    changeSuccess: { ID: "", CN: "修改成功", TR: "수정 성공" },
    pwdRule: { ID: "", CN: "密码不一致", TR: "암호 불일치" },
    accountSettings: { ID: "", CN: "账号设置", TR: "계정 설정" },

    confirmPassword: { ID: "", CN: "确定密码", TR: "암호 확인" },
    realName: { ID: "", CN: "用户名", TR: "사용자 이름" },
    corpName: { ID: "", CN: "公司名称", TR: "회사 이름" },
    corpAddress: { ID: "", CN: "公司地址", TR: "회사 주소" },

    formValidate: {
      email0: { ID: 780, CN: "请输入邮箱", TR: "메일박스 입력" },
      email1: {
        ID: 2405,
        CN: "请输入正确的邮箱格式",
        TR: "올바른 이메일 형식을 입력하십시오",
      },
      TelPhone0: {
        ID: 2406,
        CN: "请输入手机号码",
        TR: "휴대 전화 번호를 입력해 주세요",
      },
      TelPhone1: {
        ID: 2407,
        CN: "请输入正确的手机号码格式",
        TR: "올바른 휴대 전화 번호 형식을 입력하십시오",
      },
      pass0: { ID: 2408, CN: "请输入密码", TR: "암호를 입력해 주세요" },
      pass1: {
        ID: 2409,
        CN: "请输入密码长度为6~18位",
        TR: "6~18자리 길이의 암호를 입력하십시오",
      },
      pass2: { ID: 2410, CN: "请再次输入密码", TR: "암호를 다시 입력하십시오" },
      pass3: { ID: 2411, CN: "两次密码输入不一样", TR: "두 암호가 다릅니다" },
      pass4: {
        ID: "",
        CN: "密码必须包含大写或小写字母、数字、特殊字符",
        TR: "암호에는 대문자 또는 소문자, 숫자, 특수 문자가 포함되어야 합니다.",
      },
      loginName0: {
        ID: 2412,
        CN: "请输入登录名",
        TR: "로그인을 입력해 주세요",
      },
      loginName1: {
        ID: 2413,
        CN: "请输入登录名长度为6~18位",
        TR: "6~18자의 로그인을 입력하십시오",
      },
      userName0: {
        ID: 2414,
        CN: "请输入用户姓名",
        TR: "사용자 이름을 입력하세요",
      },
      corpName0: {
        ID: 2415,
        CN: "请输入公司名称",
        TR: "회사 이름을 입력하십시오",
      },
      corpAddress0: {
        ID: "",
        CN: "请输入公司地址",
        TR: "회사 주소를 입력하십시오",
      },
      tips1: {
        ID: "",
        CN: "不能包含特殊符号'或（）或*",
        TR: "특수 기호'또는() 또는 * 를 포함할 수 없습니다.",
      },
    },
  },
  // 头部header栏
  header: {
    serieslist: { ID: 1, CN: "电子样本", TR: "전자 견본" },
    selparas: { ID: 5, CN: "参数选型", TR: "파라미터 모델 선정" },
    lang: { ID: 450, CN: "语言", TR: "언어" },
    cn: { ID: 721, CN: "中文", TR: "중문" },
    en: { ID: 296, CN: "英文", TR: "영어" },
    ko: { ID: 299, CN: "韩文", TR: "한국어" },
    es: { ID: 2350, CN: "西班牙文", TR: "스페인어" },
    russian: { ID: 302, CN: "俄文", TR: "러시아어" },
    Applications: { ID: 2416, CN: "其他应用", TR: "기타 응용" },
    danji: { ID: 2417, CN: "单机版", TR: "싱글 모터 사용자 버전" },
    android: { ID: 2418, CN: "安卓", TR: "안드로이드" },
    ios: { ID: 2419, CN: "苹果", TR: "애플" },
    wechat: { ID: 2420, CN: "微信", TR: "위챗" },
    userInfo: { ID: 2532, CN: "账户信息", TR: "계정정보" },
    logout: { ID: 714, CN: "退出登录", TR: "로그아웃" },
    collectList: { ID: 2515, CN: "收藏列表", TR: "즐겨찾기 목록" },
    compareList: { ID: 847, CN: "比较列表", TR: "비교목록" },
    collect: { ID: 1743, CN: "收藏", TR: "즐겨찾기" },
    addCollect: { ID: 2516, CN: "加入收藏", TR: "즐겨찾기에 추가" },
    deleteCollect: { ID: 849, CN: "清除收藏", TR: "즐겨찾기제거" },
    compare: { ID: 698, CN: "比较", TR: "비교" },
    addCompare: { ID: 846, CN: "加入比较", TR: "비교가입" },
    deleteCompare: { ID: 848, CN: "清除比较", TR: "비교제거" },

    comparisonAdded: {
      ID: 2517,
      CN: "已经加入比较列表",
      TR: "비교 목록에 이미 추가",
    },
    addComparSueecss: {
      ID: 2518,
      CN: "加入比较列表成功",
      TR: "비교 목록 추가 성공",
    },
    clearComparList: {
      ID: 2519,
      CN: "确认清除比较列表",
      TR: "비교 목록 제거 확인",
    },
    clearComparSuccess: {
      ID: 2520,
      CN: "清除比较列表成功",
      TR: "비교 목록 제거 성공",
    },
    confirmDelCompar: {
      ID: 2521,
      CN: "确认删除此型号的比较",
      TR: "이 모델 비교를 삭제 확인",
    },
    deleteSuccess: { ID: 2522, CN: "删除成功", TR: "삭제 성공" },
    confirmDelCollect: {
      ID: 2523,
      CN: "确认删除此收藏",
      TR: "이 즐겨찾기 삭제 확인",
    },
    confirmClearCollect: {
      ID: 2524,
      CN: "确认清除收藏",
      TR: "즐겨찾기 제거 확인",
    },
    clearCollectSueecss: { ID: 2525, CN: "清除成功", TR: "제거 성공" },
    collecExists: { ID: 2526, CN: "收藏已存在", TR: "즐겨찾기에 이미 존재" },
    collectSuccess: { ID: 2527, CN: "收藏成功", TR: "즐겨찾기에 추가완료" },

    login: { ID: 2783, CN: "登录", TR: "로그인" },
    information: { ID: 2528, CN: "个人信息", TR: "개인정보" },
    tipInfo: {
      ID: 2529,
      CN: "您确定要退出系统吗",
      TR: "시스템을 종료하시겠습니까?",
    },
    tip: { ID: 286, CN: "提示", TR: "알림" },
    define: { ID: 125, CN: "确定", TR: "확정" },
    cancel: { ID: 126, CN: "取消", TR: "취소" },
    collectTip: {
      ID: 2530,
      CN: "收藏列表为空",
      TR: "즐겨찾기 목록이 비어있음",
    },
    compareTip: {
      ID: 2531,
      CN: "比较列表至少需要两项",
      TR: "비교 목록 최소 두 항목 필요",
    },

    accountModification: { ID: "",  CN: "账户修改",TR: "계정 수정" },
    accountInfo: { ID: 2532, CN: "账户信息", TR: "계정정보" },
    baseInfo: { ID: 424, CN: "基本信息", TR: "기본정보" },
    realName: { ID: 638, CN: "真实姓名", TR: "실명" },
    account: { ID: 2533, CN: "账号", TR: "계좌번호" },
    telPhoneNumber: { ID: 379, CN: "手机号", TR: "핸드폰 번호" },
    email: { ID: 1842, CN: "邮箱", TR: "이메일" },
    corpName: { ID: 102, CN: "公司名称", TR: "회사명칭" },
    corpAddress: { ID: 717, CN: "公司地址", TR: "회사주소" },
    code: { ID: "", CN: "编码", TR: "인코딩" },
    userSetting: { ID: "", CN: "用户设置", TR: "사용자 설정" },
    entryName: { ID: "", CN: "项目名称", TR: "프로젝트 이름" }, //yy add---
    companyYName: { ID: "", CN: "您的公司名", TR: "회사 이름" },
    companyType: { ID: "", CN: "类型", TR: "유형" },
    constructionParty: { ID: "", CN: "采购方/建设方", TR: "구매자/건설자" },
    projectLocation: { ID: "", CN: "项目所在地", TR: "프로젝트 위치" },
    projectCity: { ID: "", CN: "城市", TR: "도시" },
    projectArea: { ID: "", CN: "县/区", TR: "현 / 구" },
    projectDetailAddress: {
      ID: "",
      CN: "详细地址",
      TR: "상세 주소",
    },
    projectNotes: { ID: "", CN: "备注说明", TR: "설명 설명" },
    itemName: { ID: "", CN: "项目名", TR: "프로젝트 이름" }, //项目列表
    itemNo: { ID: "", CN: "项目编号", TR: "프로젝트 번호" },
    item_start_EndTime: {
      ID: "",
      CN: "开始/结束时间",
      TR: "시작 / 종료 시간",
    },
    ConsumerName: { ID: "", CN: "业主方", TR: "업주측" },
    PrjCreateTime: {
      ID: "",
      CN: "项目添加时间",
      TR: "프로젝트 추가 시간",
    },
    CustomerDistrict: { ID: "", CN: "所属区域", TR: "소속 영역" },
    C_Address: { ID: "", CN: "地址", TR: "주소" },
    itemQuery: { ID: "", CN: "查询", TR: "질의" },
    itemDelete: { ID: "", TR: "删除", TR: "삭제" },
  },
  // 底部footer 栏
  footer: {
    version: { ID: "", CN: "版本", TR: "릴리즈" },
    technical: {
      ID: 2421,
      CN: "技术支持：上海义维流体科技有限公司",
      TR: "기술지원: 상해이웨이유체테크놀로지유한회사",
    },
    technicalAddres: {
      ID: 2423,
      CN: "备案号为：沪ICP备14049296号-2",
      TR: "비안번호: 후ICP비14049296호-2",
    },
    copyright: {
      ID: 2416,
      CN: "版权所有：上海义维流体科技有限公司",
      TR: "저작권소유: 상해이웨이유체테크놀로지유한회사",
    },
    copyrightAddres: {
      ID: 2424,
      CN: "地址：上海市闵行区江月路999号1幢615",
      TR: "주소: 상해시 민항구 강월로 999호1당615",
    },
    tips: {
      ID: 2534,
      CN: "数据仅供参考：如有修改恕不通知 版权所有，盗版必究",
      TR: "데이터는 참조용으로만 제공되며 : 수정 할 경우 알림이 없을것을 양해 부탁드리며 저작권의 소유, 불법 복제물은 반드시 조사할 것입니다.",
    },
  },
  // 简易项目
  simpleProject: {
    tips1: {
      ID: "",
      CN: "请至少选中一个型号",
      TR: "하나 이상의 모델을 선택하십시오.",
    },
    tips2: { ID: "", CN: "确认返回？", TR: "반환 확인?" },
    tips3: {
      ID: "",
      CN: "确认删除此型号吗？",
      TR: "이 모델을 삭제하시겠습니까?",
    },
    tips4: { ID: "", CN: "添加失败", TR: "추가 실패" },
    tips5: { ID: "", CN: "添加成功", TR: "추가 성공" },
    tips6: { ID: "", CN: "清除收藏列表", TR: "모음집 목록 지우기" },
    auto: { ID: "", CN: "自动生成", TR: "자동 생성" },
    someAsCustomer: { ID: "", CN: "和客户一样", TR: "고객과 동일" },
    itemInfo: { ID: "", CN: "工位信息", TR: "작업 위치 정보" },
    creator: { ID: "", CN: "创建人", TR: "작성자" },
    upload: { ID: "", CN: "上传", TR: "업로드" },
    notUpload: { ID: "", CN: "未上传", TR: "업로드되지 않음" },
    lastEditor: { ID: "", CN: "最后编辑人", TR: "최종 편집자" },
    tips7: {
      ID: "",
      CN: "项目名称不能为空",
      TR: "프로젝트 이름은 비워둘 수 없습니다.",
    },
    tips8: {
      ID: "",
      CN: "此操作将删除该项目, 是否继续?",
      TR: "이 작업을 수행하면 항목이 삭제됩니다. 계속하시겠습니까?",
    },
    tips9: {
      ID: "",
      CN: "无法读取到项目信息",
      TR: "프로젝트 정보를 읽을 수 없습니다.",
    },
    tips10: { ID: "", CN: "删除失败", TR: "삭제 실패" },
    tips11: { ID: "", CN: "删除成功", TR: "삭제 성공" },
    tips12: { ID: "", CN: "已取消删除操作", TR: "삭제 작업이 취소됨" },
    tips13: {
      ID: "",
      CN: "用户名称不能为空",
      TR: "사용자 이름은 비워둘 수 없습니다.",
    },
    tips14: { ID: "", CN: "请填选客户", TR: "고객을 선택하십시오." },

    tips15: { ID: "", CN: "修改成功", TR: "수정 성공" },
    tips16: { ID: "", CN: "修改失败", TR: "수정 실패" },
    tips17: {
      ID: "",
      CN: "此操作将清空已填信息, 是否继续?",
      TR: "이 작업은 기입된 정보를 비웁니다. 계속하시겠습니까?",
    },
    tips18: { ID: "", CN: "已取消操作", TR: "작업이 취소됨" },
  },
};
